import { Routes } from '@angular/router';
import { NotAuthGuard } from '@shared/guards/not-auth.guard';
import { RoutesPath } from '@shared/enums/routes-path';

export function commonRoutes(routesPath: {
  [key in RoutesPath]: string;
}): Routes {
  return [
    {
      path: routesPath.dashboard,
      canActivate: [NotAuthGuard],
      loadChildren: () => import('@shared/pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
    },
  ];
}
